import { useContext, useEffect, useRef, useState } from "react";
import { CajasContext } from "src/context/CajasContext/CajasContext";
import { Typography, Container, Button } from '@mui/material';
import { SnackbarMessenger } from 'src/general_components/SnackbarMessenger';
import Stack from '@mui/material/Stack';
import MyModal from "src/general_components/ModalNew";
import { postContenidosBulk } from "../helpers/ImportFileData"
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import esArray from "src/general_components/functionEsArray";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { getMetadatosWhereIdTipoContenidos } from "../helpers/MetadatoData";
import { getCuentasLocalizacionesAll } from "src/projects/gestion_comercial/helpers/CuentasLocalizaciones";
import Papa from 'papaparse';
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import ExportadorCSVTipoContenidos from "./ExportadorCSVTipoContenidos";
import { ImportPreview } from "./ImportPreview";
import LinearProgress from '@mui/material/LinearProgress';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';



export const ImportFile = () => {
  const ExcelJS = require('exceljs');
  const { snackbarVisible, message, severity, setSnackbarVisible,
    setSeverity, setMessage } = useContext(CajasContext);
  const [file, setFile] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [errors, setErrors] = useState([]);
  const [successResponses, setSuccessResponses] = useState([]);
  const [errorResponses, setErrorResponses] = useState([]);
  const [tittle, setTittle] = useState("Errores de validación");
  const [clienteId, setClienteId] = useState(null);
  const [clientesList, setClientesList] = useState([]);
  const [crearCajas, setCrearCajas] = useState(false);
  const [openCSVDialog, setOpenCSVDialog] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const [previewData, setPreviewData] = useState(null);
  const [previewMetadatos, setPreviewMetadatos] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [processedCount, setProcessedCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [estimatedSecondsLeft, setEstimatedSecondsLeft] = useState(null);


  const ACCEPTED_TYPES = ['.csv', '.xls', '.xlsx'];

  const isValidFile = (f) => ACCEPTED_TYPES.some(ext => f.name.toLowerCase().endsWith(ext));

  const selectFile = (f) => {
    if (f && isValidFile(f)) {
      setFile(f);
    } else if (f) {
      setMessage("Formato no admitido. Use .csv, .xls o .xlsx");
      setSeverity("warning");
      setSnackbarVisible(true);
    }
  };

  const removeFile = () => {
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const onDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const dropped = e.dataTransfer.files[0];
    selectFile(dropped);
  };

  const handleFileChange = (e) => {
    selectFile(e.target.files[0]);
  };

  const handleImport = async () => {
    if (!clienteId || Array.isArray(clienteId) || clienteId === null) {
      setMessage("Debe seleccionar un cliente");
      setSeverity("warning");
      setSnackbarVisible(true);
      return;
    } else if (!file) {
      setMessage("Debe seleccionar un archivo");
      setSeverity("warning");
      setSnackbarVisible(true);
      return;
    }

    let parsedData = [];

    if (file.name.toLowerCase().endsWith('.csv')) {
      // PapaParse lee el File directamente: auto-detecta delimitador y encoding
      parsedData = await parseCSV(file);
    } else if (file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx')) {
      parsedData = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = async (e) => resolve(await parseExcel(e.target.result));
        reader.readAsBinaryString(file);
      });
    }

    const tiposContenido = [...new Set(parsedData.map(r => r.id_tipo_contenido).filter(Boolean))];
    const metadatos = await getMetadatosByTipos(tiposContenido);
    validateDataStructure(parsedData, metadatos);
  };

  const parseCSV = (file) => {
    return new Promise((resolve, reject) => {
      // Leer los primeros 1024 bytes para detectar el delimitador real
      const slice = file.slice(0, 1024);
      const sliceReader = new FileReader();
      sliceReader.onload = (e) => {
        const sample = e.target.result;
        const firstLine = sample.split(/\r?\n/)[0] || "";
        const commas     = (firstLine.match(/,/g)  || []).length;
        const semicolons = (firstLine.match(/;/g)  || []).length;
        const tabs       = (firstLine.match(/\t/g) || []).length;
        let delimiter = ",";
        if (semicolons > commas && semicolons >= tabs) delimiter = ";";
        else if (tabs > commas && tabs > semicolons)   delimiter = "\t";

        Papa.parse(file, {
          header: true,
          delimiter,
          encoding: "ISO-8859-1", // soporta Latin-1 / Windows-1252
          skipEmptyLines: true,
          complete: (results) => resolve(results.data),
          error: reject,
        });
      };
      sliceReader.readAsText(slice, "ISO-8859-1");
    });
  };



  const getMetadatosByTipos = async (tiposContenido) => {
    try {
      const results = await Promise.all(
        tiposContenido.map(id => getMetadatosWhereIdTipoContenidos(id))
      );
      return results.flat();
    } catch (error) {
      console.error("Error al obtener metadatos:", error);
      setMessage("No se pudieron cargar los metadatos. Reintentá la importación.");
      setSeverity("error");
      setSnackbarVisible(true);
      return [];
    }
  };




  const parseExcel = async (contents) => {
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(contents);

    const worksheet = workbook.worksheets[0];
    const jsonData = [];
    let headers = [];

    worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
      // ExcelJS incluye un elemento vacío en el índice 0 — se descarta con slice(1)
      const values = row.values.slice(1);
      if (rowNumber === 1) {
        // Primera fila → headers
        headers = values.map(v => (v !== null && v !== undefined ? String(v).trim() : ""));
      } else {
        // Filas de datos → objeto con claves nombradas (igual que PapaParse header:true)
        const obj = {};
        headers.forEach((header, idx) => {
          if (header) {
            obj[header] = values[idx] !== undefined ? values[idx] : "";
          }
        });
        jsonData.push(obj);
      }
    });

    return jsonData;
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    if (successResponses.length > 0 || errorResponses.length > 0) {
      setClienteId(null);
      setFile(null);
      setSuccessResponses([]);
      setErrorResponses([]);
    }
  };

  const validateDataStructure = async (dataExtraida, metadatos) => {
    const validationErrors = [];

    // Primero determinamos las propiedades "esperadas"
    const expectedKeys = Object.keys(
      dataExtraida.reduce((acc, obj) => {
        return Object.keys(obj).length > Object.keys(acc).length ? obj : acc;
      }, {})
    );

    // Ahora filtramos los objetos válidos
    const data = dataExtraida.filter(obj => {
      // Verifica que tenga todas las propiedades necesarias
      if (!expectedKeys.every(key => obj.hasOwnProperty(key))) {
        return false;
      }
      // Verifica que no tenga valores vacíos
      return obj;
    });


    const idTipoContenidoSet = new Set();
    const idTipoCajaSet = new Set();
    const idSectorSet = new Set();
    const idCajaSet = new Set();
    let noTieneIdTipoCaja = false;
    let noTieneIdSector = false;
    let noTieneIdTipoContenido = false;
    for (let rowIndex = 0; rowIndex < data.length; rowIndex++) {
      const meta_datosList = metadatos;
      const row = data[rowIndex];

      // Extraer campos fijos
      let {
        id_tipo_contenido,
        id_tipo_caja,
        id_sector,
        id_caja,
        lote,
        ...otrosCampos
      } = row;

      // Inicializar nuevo objeto con campos fijos
      const nuevoRow = {
        id_tipo_contenido,
        id_tipo_caja,
        id_sector,
        id_caja,
        lote,
      };

      // Procesar cada columna dinámica
      Object.entries(otrosCampos).forEach(([key, value]) => {
        if (value === "" || value === null || value === undefined) return;

        let metadata = null;

        // 🔹 Nuevo formato: id_tipo_contenido_id_metadato_label
        // Ejemplo: 342_1_Fecha
        const partes = key.split("_");

        if (partes.length >= 3) {
          // Formato id_tipo_id_meta_label: los IDs ya están en la clave, no se necesita lookup
          const idTipoContenido = partes[0];
          id_tipo_contenido = idTipoContenido;
          nuevoRow[`id_tipo_contenido`] = idTipoContenido;
          const normalizedKey = `${partes[0]}_${partes[1]}_${partes.slice(2).join('_').toLowerCase()}`;
          nuevoRow[normalizedKey] = value.toString().toUpperCase();
        } else if (partes.length === 2) {
          // Formato viejo: id_metadato_label — buscar por ID
          const idMetadato = partes[0];
          metadata = meta_datosList.find((m) => String(m.id) === idMetadato);
          if (metadata) {
            const normalizedKey = `${metadata.id_tipo_contenidos}_${metadata.id}_${metadata.label_form?.toLowerCase() ?? partes[1].toLowerCase()}`;
            nuevoRow[normalizedKey] = value.toString().toUpperCase();
          } else {
            validationErrors.push(`Advertencia: columna "${key}" no coincide con ningún metadato (Fila ${rowIndex + 1})`);
          }
        } else {
          // Formato libre: buscar por label
          metadata = meta_datosList.find(
            (m) => m.label_form?.toUpperCase() === key.toUpperCase()
          );
          if (metadata) {
            const normalizedKey = `${metadata.id_tipo_contenidos}_${metadata.id}_${metadata.label_form?.toLowerCase() ?? key.toLowerCase()}`;
            nuevoRow[normalizedKey] = value.toString().toUpperCase();
          } else {
            validationErrors.push(`Advertencia: columna "${key}" no coincide con ningún metadato (Fila ${rowIndex + 1})`);
          }
        }
      });
      // Reasignar fila modificada
      data[rowIndex] = nuevoRow;

      // Validaciones de ID requeridos
      if (!crearCajas) {
        if (!id_caja) {
          validationErrors.push(`Error: Al no crear cajas, debe ingresar el ID de caja en todas las filas. Fila ${rowIndex + 1} no tiene ID de caja`);
        }
        idCajaSet.add(id_caja);
      }

      if (crearCajas) {
        if (!id_tipo_caja) {
          noTieneIdTipoCaja = true;
          validationErrors.push(`Error: Si crea cajas debe indicar el ID de tipo de caja. Fila ${rowIndex + 1}, no tiene ID de tipo de caja`);
        }

        if (!id_sector) {
          noTieneIdSector = true;
          validationErrors.push(`Error: Fila ${rowIndex + 1}, debe indicar el ID de sector`);
        }

        idTipoCajaSet.add(id_tipo_caja);
        idSectorSet.add(id_sector);
      }

      if (!nuevoRow.id_tipo_contenido) {
        noTieneIdTipoContenido = true;
        validationErrors.push(`Error: Fila ${rowIndex + 1}, debe indicar el ID de tipo de contenido`);
      }

      idTipoContenidoSet.add(id_tipo_contenido);
    }

    // Verificar que los ID de tipo de contenido existan en local storage
    if (!noTieneIdTipoContenido) {
      for (const idTipoContenido of idTipoContenidoSet) {
        // array de todos los tipos de contenidos
        const todosTipoContenidos = JSON.parse(localStorage.getItem("siam-tipo_contenidos"))?.tipo_contenidos;

        const tipoContenidoExistente = todosTipoContenidos.find(tipoContenido => String(tipoContenido.id) === String(idTipoContenido));

        if (!tipoContenidoExistente) {
          validationErrors.push(`Error: Fila con ID de tipo de contenido ${idTipoContenido} no existe, verifique`);
        }
      }
    }

    // Verificar que los ID de tipo de caja existan en local storage
    if (!noTieneIdTipoCaja) {
      for (const idTipoCaja of idTipoCajaSet) {
        const tiposCajasLocalStorage = JSON.parse(localStorage.getItem("siam-tipo_cajas"))?.tipo_cajas;

        // Verificar la existencia del ID de tipo de caja en local storage
        const tipoCajaExistente = tiposCajasLocalStorage.find(tipoCaja => String(tipoCaja.id) === String(idTipoCaja));

        if (!tipoCajaExistente) {
          validationErrors.push(`Error: Fila con ID de tipo de caja ${idTipoCaja} no existe, verifique`);
        }
      }
    }


    // Verificar que los ID de sector existan en local storage
    if (!noTieneIdSector) {
      for (const idSector of idSectorSet) {
        // const cuentasLocalizaciones = JSON.parse(localStorage.getItem("siam-cuentas_localizaciones"))?.cuentas_localizaciones;
        const cuentasLocalizaciones = await getCuentasLocalizacionesAll();

        // Verificar la existencia del ID de sector en local storage
        const sectorExistente = cuentasLocalizaciones.find(cuentaLocalizacion => String(cuentaLocalizacion.id) === String(idSector));

        if (!sectorExistente) {
          validationErrors.push(`Error: Fila con ID de sector ${idSector} no existe, verifique`);
        }
      }
    }

    // Si hay errores después de la validación, mostrar mensajes y cortar el proceso
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      setOpenModal(true);
      return;
    }

    if (showPreview) {
      setPreviewMetadatos(metadatos);
      setPreviewData(data);
    } else {
      executeProcess(data, metadatos);
    }
  };



  // Construye el payload de una fila para el endpoint bulk
  const buildRowPayload = (row, listaMetadatos) => {
    const FIXED = new Set(["id", "id_caja", "id_tipo_caja", "id_sector", "id_tipo_contenido", "lote"]);
    const metaDatos = [];

    Object.keys(row).filter(k => !FIXED.has(k)).forEach(key => {
      const value = row[key];
      if (value === "" || value === null || value === undefined) return;

      let idMetadatos = null;
      const partes = key.split("_");
      if (partes.length >= 3) {
        idMetadatos = partes[1];
      } else if (partes.length === 2 && /^\d+$/.test(partes[0])) {
        idMetadatos = partes[0];
      } else {
        const meta = listaMetadatos.find(
          m => m.label_form && m.label_form.trim().toUpperCase() === key.trim().toUpperCase()
        );
        if (meta) idMetadatos = meta.id;
      }
      if (idMetadatos) metaDatos.push({ id: "", id_metadatos: idMetadatos, valor: value });
    });

    return {
      id: "",
      id_cajas: row.id_caja || "",
      crear_caja: crearCajas ? "1" : "0",
      id_tipo_cajas: row.id_tipo_caja || "",
      id_cuentas_localizaciones: row.id_sector || "",
      id_tipo_contenidos: row.id_tipo_contenido,
      meta_datos: metaDatos,
      lote: row.lote || "1",
    };
  };

  const executeProcess = async (parsedData, listaMetadatos) => {
    setTittle("Resultado de la importación");
    setSuccessResponses([]);
    setErrorResponses([]);
    setIsProcessing(true);
    setProcessedCount(0);
    setTotalCount(parsedData.length);
    setEstimatedSecondsLeft(null);
    setOpenModal(true);

    // Enviar todos los contenidos en una sola request bulk.
    // El servidor crea las cajas si crear_caja="1" e id_cajas está vacío.
    const bulkPayload = parsedData.map(row => buildRowPayload(row, listaMetadatos)).filter(Boolean);

    if (bulkPayload.length === 0) {
      setIsProcessing(false);
      return;
    }

    try {
      const response = await postContenidosBulk(bulkPayload);
      // XML <results><result>…</result></results> converts to wsResponse.results.result
      // (object when 1 item, array when many) — normalize with esArray
      const rawResults = response?.wsResponse?.results?.result;
      const results = rawResults ? esArray(rawResults) : [];

      if (results.length > 0) {
        results.forEach(r => {
          const ok = r.status === "true" || r.status === true;
          if (ok) {
            setSuccessResponses(prev => [...prev, {
              row:          Number(r.row),
              contenido_id: r.contenido_id,
              caja_id:      r.caja_id || null,
              caja_created: r.caja_created === "true",
            }]);
          } else {
            setErrorResponses(prev => [...prev, {
              row:     Number(r.row),
              message: r.message,
            }]);
          }
          setProcessedCount(Number(r.row));
        });
      } else {
        // Fallback: servidor devuelve solo contadores sin detalle de filas
        const created = response?.wsResponse?.created;
        const errCount = response?.wsResponse?.errors;
        if (created !== undefined) {
          setSuccessResponses([{ row: null, contenido_id: null, caja_id: null, caja_created: false, summary: `${created} contenidos importados correctamente` }]);
          if (Number(errCount) > 0) {
            setErrorResponses([{ row: null, message: `${errCount} filas fallaron — revisá los datos` }]);
          }
        } else {
          setErrorResponses([{ row: null, message: "No se recibió respuesta del servidor" }]);
        }
      }
    } catch (err) {
      setErrorResponses(prev => [...prev, { row: null, message: `Error al contactar el servidor: ${err.message}` }]);
    }

    setIsProcessing(false);
    setEstimatedSecondsLeft(null);
  };

  useEffect(() => {
    // Actualizar los arrays de mensajes al cambiar successfulResponses y errorResponses
    if (successResponses.length > 0 || errorResponses.length > 0) {
      setOpenModal(true);
    }
  }, [successResponses, errorResponses]);



  useEffect(() => {
    setClienteId(null);
    const getClientes = async () => {
      var clientes = [];
      let cuentas = esArray(JSON.parse(localStorage.getItem("siam-service-getCuentasGenericas")).cuentas);
      let condicionIN = false;


      let clients = esArray(JSON.parse(localStorage.getItem("siam-cuentas_personas_juridicas")).cuentas_personas_juridicas);
      clientes = clients.filter((cliente) =>
        cuentas.find(
          (cuenta) => {
            if (condicionIN === true) {
              return cuenta.id_cuentas === cliente.id_cuentas

            } else {
              return cuenta.id_cuentas !== cliente.id_cuentas
            }
          }
        )
      );

      const user_cuentas = JSON.parse(localStorage.getItem("siam-user-cuentas"));
      let userCuentasStorage = esArray(user_cuentas);
      if (userCuentasStorage.length < 2) {
        let usersCuentasModificado = [{ usuarios_cuentas: userCuentasStorage[0] }]
        userCuentasStorage = usersCuentasModificado;
      }
      if (user_cuentas.length > 0) {
        let clientesFilter = clientes.filter((cliente) => userCuentasStorage.find((obj) => obj.usuarios_cuentas.id_cuentas === cliente.id_cuentas))
        let newClientes = Object.entries(clientesFilter).map(([key, value]) => {
          let objeto = value;
          objeto["label"] = value.razon_social;
          return objeto;
        });
        setClientesList(newClientes);
      } else {
        let newClientes = Object.entries(clientes).map(([key, value]) => {
          let objeto = value;
          objeto["label"] = value.razon_social;
          return objeto;
        });
        setClientesList(newClientes);
      }
    };
    getClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const estilosSelect = {
    fontSize: "1em", color: "#646464", fontFamily: 'Roboto, sans-serif',
    borderRadius: 10,
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
  };

  // Función personalizada de filtrado para buscar dentro del objeto cliente por id y razon_social
  const filterOptions = (options, { inputValue }) => {
    return options.filter((option) => {
      const label = option.label.toLowerCase();
      const inputValueLowerCase = inputValue.toLowerCase();
      const idString = option.id_cuentas.toString().toLowerCase();
      return label.includes(inputValueLowerCase) || idString.includes(inputValueLowerCase);
    });
  };

  const handleChangeCrearCajas = () => {
    // La función que se ejecutará al cambiar el estado del Switch
    setCrearCajas(!crearCajas);
  };

  const handleOpenCSVDialog = async () => {
    setOpenCSVDialog(!openCSVDialog);
    // const metadatos = await getMetadatos();
    // setMetadatosSeleccionables(metadatos);
  };




  const dialogChild = (
    <ExportadorCSVTipoContenidos></ExportadorCSVTipoContenidos>
  );



  if (previewData !== null) {
    return (
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <ImportPreview
          data={previewData}
          onConfirm={(cleanData) => {
            setPreviewData(null);
            executeProcess(cleanData, previewMetadatos);
          }}
          onBack={() => setPreviewData(null)}
        />
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>

      {/* ── Título ── */}
      <Typography variant="h6" fontWeight={700} gutterBottom>
        Importación de Contenidos
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Cargá un archivo CSV o Excel para importar contenidos masivamente al sistema.
      </Typography>

      {/* ── Instrucciones colapsables ── */}
      <Accordion elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, mb: 3, '&:before': { display: 'none' } }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoOutlinedIcon fontSize="small" color="info" />
            <Typography variant="body2" fontWeight={600}>¿Cómo funciona la importación?</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2}>
            <Box>
              <Typography variant="body2" fontWeight={600} gutterBottom>Columnas fijas (siempre requeridas)</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                {['id_tipo_contenido', 'id_caja', 'id_tipo_caja', 'id_sector', 'lote'].map(col => (
                  <Chip key={col} label={col} size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }} />
                ))}
              </Box>
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                <strong>id_caja</strong>: requerido cuando <em>no</em> se crean cajas. &nbsp;
                <strong>id_tipo_caja</strong> e <strong>id_sector</strong>: requeridos cuando se crean cajas.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="body2" fontWeight={600} gutterBottom>Columnas de metadatos (dinámicas)</Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                El encabezado de cada columna de metadato debe seguir el formato:
              </Typography>
              <Chip label="id_tipo_contenido_id_metadato_label" size="small" color="info" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', mb: 1 }} />
              <Typography variant="caption" color="text.secondary" display="block">
                Ejemplo: <code>342_1_Fecha</code> → tipo de contenido 342, metadato ID 1, etiqueta "Fecha".
                También se acepta el formato legado <code>id_metadato_label</code> o directamente el nombre del campo.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="body2" fontWeight={600} gutterBottom>Opción "Crear cajas"</Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Desactivado (por defecto):</strong> los contenidos se agregan a cajas ya existentes. Cada fila debe tener un <code>id_caja</code> válido.<br />
                <strong>Activado:</strong> se crea una caja nueva por fila usando <code>id_tipo_caja</code> e <code>id_sector</code>, y luego se asocian los contenidos.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="body2" fontWeight={600} gutterBottom>Plantilla de ejemplo</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Generá un CSV con la estructura correcta para el tipo de contenido que necesitás importar.
              </Typography>
              <Button size="small" variant="outlined" onClick={handleOpenCSVDialog}>
                Generar plantilla (CSV / XLSX)
              </Button>
            </Box>
          </Stack>
        </AccordionDetails>
      </Accordion>

      {/* ── Formulario ── */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>

        {/* Cliente + Switch */}
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          <Box sx={{ flex: 1, minWidth: 220 }}>
            <Autocomplete
              size="small"
              value={clienteId}
              onChange={(event, newValue) => setClienteId(newValue)}
              id="import-cliente"
              options={clientesList}
              filterOptions={filterOptions}
              style={estilosSelect}
              disableClearable={true}
              renderOption={(props, option) => (
                <Box component="li" {...props} key={option.id}>
                  {option.id_cuentas + ' - ' + option.label}
                </Box>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Cliente *" InputProps={{ ...params.InputProps, type: 'search' }} />
              )}
            />
          </Box>
          <FormControlLabel
            control={
              <Switch
                checked={crearCajas}
                onChange={handleChangeCrearCajas}
                inputProps={{ "aria-label": "crear cajas" }}
              />
            }
            label={
              <Typography variant="body2" fontWeight={500}>
                Crear cajas automáticamente
              </Typography>
            }
          />
        </Box>

        {/* Dropzone custom */}
        <Box>
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv,.xls,.xlsx"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />

          {!file ? (
            /* Zona de drop vacía */
            <Box
              onClick={() => fileInputRef.current?.click()}
              onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
              onDragLeave={() => setIsDragging(false)}
              onDrop={onDrop}
              sx={{
                border: '2px dashed',
                borderColor: isDragging ? 'primary.main' : 'divider',
                borderRadius: 2,
                p: 4,
                textAlign: 'center',
                cursor: 'pointer',
                bgcolor: isDragging ? 'primary.50' : 'background.default',
                transition: 'all 0.2s',
                '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' },
              }}
            >
              <UploadFileIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
              <Typography variant="body1" fontWeight={500} color="text.secondary">
                Arrastrá el archivo aquí o hacé clic para seleccionarlo
              </Typography>
              <Typography variant="caption" color="text.disabled" sx={{ mt: 0.5, display: 'block' }}>
                Formatos admitidos: .csv · .xls · .xlsx · máx. 5 MB
              </Typography>
            </Box>
          ) : (
            /* Archivo seleccionado */
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                border: '1px solid',
                borderColor: 'success.light',
                borderRadius: 2,
                p: 2,
                bgcolor: 'success.50',
              }}
            >
              <InsertDriveFileIcon sx={{ color: 'success.main', fontSize: 32, flexShrink: 0 }} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" fontWeight={600} noWrap>{file.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {(file.size / 1024).toFixed(1)} KB · listo para importar
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => fileInputRef.current?.click()}
                  sx={{ fontSize: '0.75rem' }}
                >
                  Cambiar
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={removeFile}
                  startIcon={<CloseIcon fontSize="small" />}
                  sx={{ fontSize: '0.75rem' }}
                >
                  Quitar
                </Button>
              </Box>
            </Box>
          )}
        </Box>

        {/* Botón importar + switch vista previa */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleImport}
            disabled={!file || !clienteId}
            sx={{ minWidth: 160 }}
          >
            Importar
          </Button>
          {(!file || !clienteId) ? (
            <Typography variant="caption" color="text.secondary">
              {!clienteId ? 'Seleccioná un cliente' : 'Seleccioná un archivo'}
            </Typography>
          ) : null}
          <FormControlLabel
            control={
              <Switch
                checked={showPreview}
                onChange={() => setShowPreview(v => !v)}
                size="small"
              />
            }
            label={
              <Typography variant="body2" color="text.secondary">
                Vista previa antes de procesar
              </Typography>
            }
            sx={{ ml: 'auto' }}
          />
        </Box>
      </Box>

      {/* ── Modales ── */}
      <MyModal
        open={openModal}
        onClose={handleCloseModal}
        title={tittle}
        content={
          <>
            {/* ── Errores de validación ── */}
            {errors.length > 0 && (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <WarningAmberIcon sx={{ color: 'warning.main', fontSize: 20 }} />
                  <Typography variant="body2" fontWeight={700}>
                    {errors.filter(e => e.startsWith('Error:')).length > 0
                      ? `${errors.filter(e => e.startsWith('Error:')).length} error${errors.filter(e => e.startsWith('Error:')).length !== 1 ? 'es' : ''} encontrado${errors.filter(e => e.startsWith('Error:')).length !== 1 ? 's' : ''}`
                      : `${errors.length} advertencia${errors.length !== 1 ? 's' : ''}`}
                  </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
                  Corregí los problemas en el archivo antes de continuar.
                </Typography>
                <Stack spacing={0.5}>
                  {errors.map((error, index) => {
                    const isError = error.startsWith('Error:');
                    return (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex', gap: 1, alignItems: 'flex-start',
                          p: 1, borderRadius: 1,
                          bgcolor: isError ? '#FFF3F3' : '#FFFDE7',
                          borderLeft: '3px solid',
                          borderColor: isError ? 'error.main' : 'warning.main',
                        }}
                      >
                        <ErrorOutlineIcon sx={{ fontSize: 14, color: isError ? 'error.main' : 'warning.main', mt: 0.3, flexShrink: 0 }} />
                        <Typography variant="caption" sx={{ lineHeight: 1.6 }}>{error}</Typography>
                      </Box>
                    );
                  })}
                </Stack>
              </Box>
            )}

            {/* ── Resultado de importación ── */}
            {(isProcessing || successResponses.length > 0 || errorResponses.length > 0) && errors.length === 0 && (
              <Box>
                {/* Progreso */}
                {isProcessing && (
                  <Box sx={{ mb: 2.5 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.75 }}>
                      <Typography variant="body2" fontWeight={600}>
                        {crearCajas && processedCount < totalCount
                          ? `Creando cajas… ${processedCount} / ${totalCount}`
                          : `Importando ${totalCount} registro${totalCount !== 1 ? 's' : ''}…`
                        }
                      </Typography>
                      {estimatedSecondsLeft !== null ? (
                        <Typography variant="caption" color="text.secondary">
                          ~{estimatedSecondsLeft < 60
                            ? `${estimatedSecondsLeft}s`
                            : `${Math.floor(estimatedSecondsLeft / 60)}m ${estimatedSecondsLeft % 60}s`
                          } restantes
                        </Typography>
                      ) : (
                        <Typography variant="caption" color="text.disabled">
                          {crearCajas ? 'Calculando…' : 'Enviando al servidor…'}
                        </Typography>
                      )}
                    </Box>
                    <LinearProgress
                      variant={crearCajas ? "determinate" : "indeterminate"}
                      value={crearCajas && totalCount > 0 ? (processedCount / totalCount) * 100 : 0}
                      sx={{ borderRadius: 1, height: 6 }}
                    />
                    {crearCajas && (
                      <Typography variant="caption" color="text.disabled" sx={{ mt: 0.5, display: 'block' }}>
                        {totalCount > 0 ? Math.round((processedCount / totalCount) * 100) : 0}% — creando cajas antes de importar contenidos
                      </Typography>
                    )}
                  </Box>
                )}

                {!isProcessing && (successResponses.length > 0 || errorResponses.length > 0) && (() => {
                  const total   = successResponses.length + errorResponses.length;
                  const allOk   = errorResponses.length === 0;
                  const allFail = successResponses.length === 0;
                  const bannerColor  = allOk ? '#1B5E20' : allFail ? '#B71C1C' : '#E65100';
                  const bannerBg     = allOk ? '#F1F8E9' : allFail ? '#FFF3F3' : '#FFF8F0';
                  const bannerBorder = allOk ? '#A5D6A7' : allFail ? '#FFCDD2' : '#FFCC80';
                  const bannerIcon   = allOk
                    ? <CheckCircleOutlineIcon sx={{ fontSize: 20, color: bannerColor }} />
                    : allFail
                      ? <ErrorOutlineIcon sx={{ fontSize: 20, color: bannerColor }} />
                      : <WarningAmberIcon sx={{ fontSize: 20, color: bannerColor }} />;
                  const bannerText = allOk
                    ? `${total} registro${total !== 1 ? 's' : ''} importado${total !== 1 ? 's' : ''} correctamente`
                    : allFail
                      ? `Importación fallida — ${total} error${total !== 1 ? 'es' : ''}`
                      : `${successResponses.length} importado${successResponses.length !== 1 ? 's' : ''}, ${errorResponses.length} error${errorResponses.length !== 1 ? 'es' : ''}`;

                  return (
                    <>
                      {/* Banner */}
                      <Box sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5,
                        px: 2, py: 1.25, mb: 2, borderRadius: 2,
                        bgcolor: bannerBg, border: '1px solid', borderColor: bannerBorder,
                      }}>
                        {bannerIcon}
                        <Typography variant="body2" fontWeight={700} sx={{ color: bannerColor }}>
                          {bannerText}
                        </Typography>
                      </Box>

                      {/* Stats */}
                      <Box sx={{ display: 'flex', gap: 1.5, mb: 2.5 }}>
                        {[
                          { value: total, label: 'Total', color: '#1565C0', bg: '#E3F2FD' },
                          { value: successResponses.length, label: 'Exitosos', color: '#2E7D32', bg: '#E8F5E9' },
                          { value: errorResponses.length, label: 'Errores', color: '#C62828', bg: '#FFEBEE' },
                        ].map(({ value, label, color, bg }) => (
                          <Box key={label} sx={{ flex: 1, textAlign: 'center', py: 1.25, borderRadius: 2, bgcolor: bg }}>
                            <Typography variant="h5" fontWeight={800} sx={{ color, lineHeight: 1 }}>{value}</Typography>
                            <Typography variant="caption" sx={{ color, opacity: 0.85 }}>{label}</Typography>
                          </Box>
                        ))}
                      </Box>

                      {/* Exitosos */}
                      {successResponses.length > 0 && (
                        <Box sx={{ mb: errorResponses.length > 0 ? 2 : 0 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                            <CheckCircleOutlineIcon sx={{ fontSize: 14, color: 'success.main' }} />
                            <Typography variant="caption" fontWeight={700} color="success.main" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                              Registros importados
                            </Typography>
                          </Box>
                          <Stack spacing={0.35}>
                            {successResponses.map((r, i) => (
                              <Box
                                key={i}
                                sx={{
                                  display: 'flex', alignItems: 'center', gap: 1,
                                  px: 1.25, py: 0.75, borderRadius: 1.5,
                                  bgcolor: '#F1F8E9', border: '1px solid #C8E6C9',
                                }}
                              >
                                {r.row != null && (
                                  <Chip
                                    label={`F.${r.row}`}
                                    size="small"
                                    sx={{ fontSize: '0.65rem', fontWeight: 700, height: 18, bgcolor: '#A5D6A7', color: '#1B5E20', flexShrink: 0 }}
                                  />
                                )}
                                <Typography variant="caption" sx={{ fontFamily: 'monospace', fontWeight: 600, color: '#1B5E20' }}>
                                  {r.contenido_id ? `Contenido #${r.contenido_id}` : (r.summary || '—')}
                                </Typography>
                                {r.caja_id && (
                                  <Chip
                                    label={r.caja_created ? `Caja nueva #${r.caja_id}` : `Caja #${r.caja_id}`}
                                    size="small"
                                    sx={{
                                      fontSize: '0.65rem', height: 18, ml: 'auto', flexShrink: 0,
                                      bgcolor: r.caja_created ? '#E3F2FD' : '#F3E5F5',
                                      color:   r.caja_created ? '#1565C0' : '#6A1B9A',
                                    }}
                                  />
                                )}
                              </Box>
                            ))}
                          </Stack>
                        </Box>
                      )}

                      {/* Errores */}
                      {errorResponses.length > 0 && (
                        <Box>
                          {successResponses.length > 0 && <Divider sx={{ mb: 2 }} />}
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                            <ErrorOutlineIcon sx={{ fontSize: 14, color: 'error.main' }} />
                            <Typography variant="caption" fontWeight={700} color="error.main" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                              Errores al importar
                            </Typography>
                          </Box>
                          <Stack spacing={0.5}>
                            {errorResponses.map((r, i) => {
                              const colonIdx = r.message ? r.message.indexOf(': ') : -1;
                              const step   = colonIdx > -1 ? r.message.slice(0, colonIdx) : r.message;
                              const detail = colonIdx > -1 ? r.message.slice(colonIdx + 2) : null;
                              return (
                                <Box
                                  key={i}
                                  sx={{
                                    display: 'flex', gap: 1.25, alignItems: 'flex-start',
                                    px: 1.25, py: 0.85, borderRadius: 1.5,
                                    bgcolor: '#FFF3F3', border: '1px solid #FFCDD2',
                                    borderLeft: '3px solid', borderLeftColor: 'error.main',
                                  }}
                                >
                                  {r.row != null && (
                                    <Chip
                                      label={`F.${r.row}`}
                                      size="small"
                                      sx={{ fontSize: '0.65rem', fontWeight: 700, height: 18, bgcolor: '#FFCDD2', color: '#B71C1C', flexShrink: 0, mt: 0.1 }}
                                    />
                                  )}
                                  <Box sx={{ minWidth: 0 }}>
                                    <Typography variant="caption" fontWeight={700} sx={{ color: '#B71C1C', display: 'block', lineHeight: 1.4 }}>
                                      {step}
                                    </Typography>
                                    {detail && (
                                      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.4 }}>
                                        {detail}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              );
                            })}
                          </Stack>
                        </Box>
                      )}
                    </>
                  );
                })()}
              </Box>
            )}
          </>
        }
      />
      <SimpleDialogComponent
        open={openCSVDialog}
        modalName={"Generar plantilla de importación"}
        child={dialogChild}
        handleClose={handleOpenCSVDialog}
        buttonEnviar={false}
        buttonCancelar={false}
        maxWidth="md"
      />
      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => { setSnackbarVisible(false) }}
        hide={8000}
      />
    </Container>
  );
};

export default ImportFile;